import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'
export const InputContainer = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  alignItems: 'center',
  '& > *': {
    flex: '0 1 50%'
  },
  '& > *:not(:first-of-type)': {
    marginLeft: '1rem'
  }
}))
